import options from './trigger-webhook.component';

export default {
    selector: 'dtAlertsActionsTriggerWebhook',
    options
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/actions/trigger-webhook/index.js